import React from 'react'
import { params } from '../../../../../../redux/reducers/reducer'
import WallNameTemplate from '../../../../WallName/WallNameTemplete';

const WallName = () => {

    let wallTemplates = [
        { position: [0, 0, (params.p_d / 2 + params.leanF_p_d + 1)], rotation: [0, 0, 0], slopeAngle: 60, value: 'Front Building Front' },
        { position: [(params.leanF_p_w / 2 + 1), 0, (params.p_d / 2 + params.leanF_p_d / 2)], rotation: [0, Math.PI / 2, 0], slopeAngle: 60, value: 'Front Building Right' },
        { position: [-(params.leanF_p_w / 2 + 1), 0, (params.p_d / 2 + params.leanF_p_d / 2)], rotation: [0, -Math.PI / 2, 0], slopeAngle: 60, value: 'Front Building Left' }
    ]

    if(params.add_storage_check_front && params.frontLeanStoragePosition != 0){
        let positionX = params.p_d /2 + params.frontLeanStoragePosition + 0.01;
        let frontStorage = {
             position: [0, 0, positionX], 
             rotation: [0,  Math.PI, 0], 
             slopeAngle: 60,     
             value:  'Front Building Storage Back'
            };

        wallTemplates = [...wallTemplates,frontStorage]
    }
    if(params.add_storage_check_front && params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front)){
        let positionX = params.p_d /2 + parseInt(params.add_storage_front) + params.frontLeanStoragePosition + 0.01;
        let frontStorage = {
             position: [0, 0, positionX], 
             rotation: [0, 0, 0], 
             slopeAngle: 60,
             value:  'Front Building Storage Front'
            };

        wallTemplates = [...wallTemplates,frontStorage]
    }
    return (
        <>
            {wallTemplates.map((template, index) => (
                <WallNameTemplate
                    key={index}
                    position={template.position}
                    rotation={template.rotation}
                    value={template.value}
                    slopeAngle={template.slopeAngle}
                />
            ))}
        </>
    )
}

export default WallName